 import React from "react"
import CounterBtn from "./CounterBtn"
import MultilineTextEllipses from "../../UI/MultilineTextEllipses/MultilineTextEllipses"
import classes from "./Cart.module.css"
import {capitalizeFirstLetter} from "../../../store/utility"
import * as actions from "../../../store/actions/index"
import {connect} from "react-redux"
 
 const CartRow = props=>{ 
     let product  = props.product 
    // console.log(product)
     const getAttributes = ()=>{
        let attrs = [];
        if(product.attributes){
            let attributes = product.attributes;
            for(let attrkey in attributes ){
                attrs.push(
                    <div>
                        <strong>{capitalizeFirstLetter(attributes[attrkey].attribute)}</strong>
                        : {attributes[attrkey].name}
                    </div>
                )
            } 
            return attrs;
        }else{
            return null
        }
     }
    //  const handleOnCounterUpdate = async (action,product)=>{
    //     try{
    //             throw new Error("Server Error")
    //             if(action=="increment"){
    //                 let res = await props.addProductToCartSync(props.userId,product,action)
    //             }else if(action=="decrement") {
    //                 await props.addProductToCartSync(props.userId,product,action)
    //             }else{
    //                 return alert("Action specified wrong")
    //             }

    //     }catch(error){ 
            
    //         return alert(error)
    //     }
    //  }
     return( 


        <div className={`d-flex flex-nowrap  p-2 ${classes.Row}`} >
            
                <button className={`btn btn-sm ${classes.Cross}` }
                    onClick={()=>props.onRemoveProductFromCart(props.userId,product,props.includeDeliveryComputation)}
                    disabled={props.disabled}
                >
                    <i className={`fa fa-times-circle `} aria-hidden="true" 
                        
                        
                    ></i>
                </button>
                
             
           
            
            <div>
                <img src={product.previewImages[0]} style={{width:"90px",height:"90px"}}/>

            </div>
           
            <div className={classes.ItemRight}> 
            
                <div className={classes.Desc}> 
                    <MultilineTextEllipses>
                    <a href="#">{product.productTitle}</a>
                    </MultilineTextEllipses> 

                    {
                        getAttributes()
                    }
                     
                 </div>
               {product.stock?(  <div className={classes.Counter}>
                   <div>
                   <label style={{textDecoration:"line-through"}}>Rs.{product.regularPrice*product.quantity}</label>
                   </div > 
                   <div> 
                   <CounterBtn
                        productId={product.variantId?product.variantId:product.id}
                        key={product.variantId?product.variantId:product.id}
                        stock={product.stock}
                        defaultValue={product.quantity} 
                        disabled={props.disabled}
                        runOnCounterUpdate={(action,id)=>{

                            return new Promise(async(resolve,reject)=>{
                                
                                try{
                                    
                                    if(action=="increment"){
                                        let res = await props.addProductToCartSync(props.userId,product,action,props.includeDeliveryComputation)
                                        resolve(true)
                                    }else if(action=="decrement") {
                                        await props.addProductToCartSync(props.userId,product,action,props.includeDeliveryComputation)
                                        resolve(true)
                                    }else{
                                        return alert("Action specified wrong")
                                    }
                    
                            }catch(error){
                                reject(error)
                                // return alert(error)
                            }
                               
                                
                                
                            })

                        }} 
                    />  
                        
                   </div>
                     
                   <div > 
                   <label>Rs.{product.salePrice*product.quantity}</label>
                   </div>
                   
                </div>):
                    <div className={`text-center text-danger ${classes.Counter}`} style={{flex:1}} > 
                        <h5>Out Of Stock</h5>
                    </div>
                }
              
            </div>
            
        </div>
     )
 }
 const mapStateToProps = state=>{
     return{
        userId:state.auth.userId,
     }
 }

 const mapDispatchToProps = dispatch=>{
     return{
        addProductToCartSync:(userId,product,action,includeDeliveryComputation)=>dispatch(actions.addProductSyncronously(userId,product,action,includeDeliveryComputation)),
       onRemoveProductFromCart:(userId,product,includeDeliveryComputation)=>dispatch(actions.removeProductFromCart(userId,product,includeDeliveryComputation))
     }
 }
 export default connect(mapStateToProps,mapDispatchToProps)(CartRow);